import React from 'react';

import { Title } from '@mantine/core';
import PageHeader from 'components/PageHeader';

import AccountingCard from './components/AccountingCard';
import AthleteAttendanceCard from './components/AthleteAttendanceCard';
import AthleteBirthdaysCard from './components/AthleteBirthdaysCard';
import AthletesCard from './components/AthletesCard';
import BusinessMetricsCard from './components/BusinessMetricsCard';
import OnboardingChecklistBanner from './components/OnboardingChecklistBanner';
import PackageCategoryRevenueCard from './components/PackageCategoryRevenueCard';
import PackageRevenueCard from './components/PackageRevenueCard';
import PaymentsCard from './components/PaymentsCard';
import ReservationCard from './components/ReservationCard';
import UtilizationCard from './components/UtilizationCard';
import { useDashboardStyles } from './styles';

const Dashboard = (): JSX.Element => {
  const { classes } = useDashboardStyles();

  return (
    <>
      <PageHeader>
        <Title order={1} size='h1' data-cy='dashboard'>
          Dashboard
        </Title>
      </PageHeader>

      <div className={classes.scroll}>
        <div className={classes.layout}>
          <OnboardingChecklistBanner className={classes.banner} />

          <BusinessMetricsCard />

          <AccountingCard />

          <PaymentsCard />

          <AthletesCard />

          <UtilizationCard />

          <ReservationCard />

          <PackageRevenueCard />

          <PackageCategoryRevenueCard />

          <AthleteAttendanceCard />

          <AthleteBirthdaysCard />
        </div>
      </div>
    </>
  );
};

export default Dashboard;
